
import { CommonsNewHttpUtilsErrorService } from 'ib-web-commons/app/core/utils/http-utils-services/ib-commons-new-http-utils-error-service';
import { SubscriptionModelsImportModelService } from '../ib-subscription-models-import/ib-subscription-models-import-model-service';
import * as angular from 'angular';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';
import { Types } from '@src/app/core/models/configuration.model';
export class SubscriptionModelsConfigurationService {
    private originDestination: string;
    constructor (
        private $filter: angular.IFilterService,
        private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant,
        private CommonsGenericProxy: CommonsGenericProxy,
        private SubscriptionModelsImportModelService: SubscriptionModelsImportModelService,
        private $location: ng.ILocationService,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsModalService: CommonsModalService,
        private CommonsKeepAliveUtilsService: any,
        private CurrencyService: any,
        private SubscriptionModelsRouterConstants: SubscriptionModelsRouterConstants,
        private CommonsSessionStorageService: CommonsSessionStorageService
    ) {}

    initShow = (): Types.show => {
        const show = {
            showImport: false,
            showImportButton: true,
            showRecalculateButton: false
        };
        return show;
    };
    generateGetAvailabilityModel = (configurationModel: Types.ConfigurationModel) => {
        return {
            type: this.SubscriptionModelsAppConstants.TYPE,
            market: configurationModel.market,
            origin: configurationModel.body.origin.code,
            destination: configurationModel.body.destination.code
        };
    };
    getAvailability = (availabilityData: Types.availabilityRequest): angular.IPromise<Types.AvailabilitySubscriptionModelsResponse|any> => {

        const endpoint = this.SubscriptionModelsAppConstants.DEFAULT_ENDPOINTS.AVAILABILITY;
        this.CommonsModalService.showWaitingModal();
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };
        return new Promise( (resolve, reject) => {
            this.CommonsGenericProxy.postGeneric(endpoint, availabilityData, headerConfig).then((response) => {
                const data : Types.AvailabilitySubscriptionModelsResponse  = this.SubscriptionModelsImportModelService.transformInfo( <Types.AvailabilitySubscriptionModelsResponse>response.data);
                this.CommonsSessionStorageService.set('flowId', data.flowId);
                this.CommonsModalService.finishWaiting();
                resolve(data);
            }, (error) => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);

                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.showGenericError(error, true, null).then(angular.noop, angular.noop);
            });
        });

    };

    transformData = (formModel:Types.ConfigurationModel, campaignId: string, checkFrequentCompanion: boolean) => {
        let passengers = {};
        if (checkFrequentCompanion) {
            passengers = {
                mainPassenger: {
                    name: formModel.body.mainPassenger.name,
                    surname: formModel.body.mainPassenger.surname,
                    email: formModel.body.mainPassenger.email
                },
                accompanyingPassenger: {
                    name: formModel.body.accompanyingPassenger.name,
                    surname: formModel.body.accompanyingPassenger.surname,
                    email: formModel.body.accompanyingPassenger.email
                }
            };
        } else {
            passengers = {
                mainPassenger: {
                    name: formModel.body.mainPassenger.name,
                    surname: formModel.body.mainPassenger.surname,
                    email: formModel.body.mainPassenger.email
                }
            };
        }
        const transformedData = {
            type: formModel.type,
            amount: formModel.body.amount,
            currency: formModel.body.currency.code,
            passengers: passengers,
            campaignId: campaignId
        };

        return transformedData;
    };

    getOriginsDestinations = (type, origin?): angular.IPromise<any | Types.ErrorResponse> => {
        let endpoint: string;
        this.originDestination = type;

        if(type == 'origin') {
            endpoint = this.SubscriptionModelsAppConstants.DEFAULT_ENDPOINTS.ORIGINS;
            let marketLang:any = this.CommonsSessionStorageService.get('marketLang');
            endpoint = endpoint + 'market=' + marketLang.market;
        }else {
            this.CommonsModalService.showWaitingModal();
            endpoint = this.SubscriptionModelsAppConstants.DEFAULT_ENDPOINTS.DESTINATIONS;
            let marketLang:any = this.CommonsSessionStorageService.get('marketLang');
            endpoint = endpoint + 'market=' + marketLang.market;
            endpoint = endpoint.replaceAll('{fromOrigin}', origin);
        }
        const headerConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept': '*/*'
            }
        };
        return new Promise( (resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(`${endpoint}`, null, null, headerConfig).then((response) => {
                resolve(response.data);
                this.CommonsModalService.closeAllCurrentModals();
                this.CommonsModalService.finishWaiting();
            }, (error) => {
                this.CommonsModalService.closeAllCurrentModals();
                this.CommonsModalService.finishWaiting();
                if(this.originDestination === 'origin') {
                    this.$location.path(this.SubscriptionModelsRouterConstants.PAGES_URL.SUBSCRIPTIONMODELS_ERROR);
                }else {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                }
            });
        });
    };
    putSubscriptionModels = (data:Types.PutSubscriptionModelsRequest): angular.IPromise<any | Types.ErrorResponse> => {
        let endpoint: string = this.SubscriptionModelsAppConstants.DEFAULT_ENDPOINTS.SUBSCRIPTIONMODELS;
        endpoint = endpoint.replace('{flowId}', this.CommonsSessionStorageService.get('flowId'));
        this.CommonsModalService.showWaitingModal();

        return new Promise( (resolve, reject) => {
            this.CommonsGenericProxy.putGeneric(`${endpoint}`, data).then((response) => {
                this.CommonsModalService.finishWaiting();
                this.CommonsKeepAliveUtilsService.initKeepAlive();
                resolve(response);

            }, (error) => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                this.CommonsModalService.finishWaiting();

            });
        });
    };

    getModelConditions = (campaignSelected, modelForm: Types.ConfigurationModel) => {
        const amount = this.CurrencyService.formatPrice(modelForm.body.currency, modelForm.body.amount, true, false, false);
        const conditionModel = {
            jurney: modelForm.body.origin.description + ' - ' + modelForm.body.destination.description + ' / ' + modelForm.body.destination.description + ' - ' + modelForm.body.origin.description,
            operatorsRestrictionInfo: campaignSelected?.operatorsRestriction,
            from: campaignSelected?.expiryDateFrom,
            to: campaignSelected?.expiryDateTo,
            text:  amount + ' (' + this.$filter('translate')('SUBSCRIPTION_MODELS_CONDITION_MODAL_BODY_TO_PAY') + this.CurrencyService.formatPrice(modelForm.body.currency, campaignSelected?.discount.amount, true, false, false) +  ') '  + this.$filter('translate')('GENERAL_DISCOUNT') + ' ' + campaignSelected?.discount.percentage +'%',
            maxUsagesInfo: this.$filter('translate')('SUBSCRIPTION_MODELS_MIN_USES'),
            flightDateReturnLimit: campaignSelected?.flightDateReturnLimit,
            mainPassenger: modelForm.body.mainPassenger.name + ' ' + modelForm.body.mainPassenger.surname,
            accompanyingPassenger: ' '
        };
        if(modelForm.body.accompanyingPassenger){
            conditionModel.accompanyingPassenger = modelForm.body.accompanyingPassenger.name + ' ' + modelForm.body.accompanyingPassenger.surname;
        }
        return conditionModel;
    };

    getQuadrigam = ():string => {
        let quadrigam:string;
        const redirectionPaymentCallback = this.CommonsSessionStorageService.get('redirectionPaymentCallback');
        if (redirectionPaymentCallback) {
            quadrigam = this.SubscriptionModelsAppConstants.QUADRIGAMS.GIFTCARDS_PAYMENT;
        }else{
            quadrigam = this.SubscriptionModelsAppConstants.QUADRIGAMS.PLAPAX;
        }
        return quadrigam;
    };

    initializeModel = (): Types.ConfigurationModel => {
        const marketLang: any = this.CommonsSessionStorageService.get('marketLang');
        return{
            type: 'SUBSCRIPTION',
            market:  marketLang.market,
            body:{
                subtype: 'OD',
                origin: {
                    code: '',
                    country: '',
                    description: '',
                    group: ''
                },
                destination: {
                    code: '',
                    country: '',
                    description: '',
                    group: ''
                },
                frequency: {
                    id: 0,
                    name: '0'
                },
                mainPassenger: {
                    name: '',
                    surname: '',
                    email: ''
                },
                amount: 0,
                flowId: ''
            }
        };
    };
    customImportInfo = () => {
        return {
            currency: {
                suffixSymbol: true,
                decimalSeparator: ',',
                numberDecimals: 2,
                groupingSeparator: '.',
                currencySymbol: '€',
                description: 'Euro',
                code: 'EUR'
            },
            fixedPrices: [
                {
                    amount: 50,
                    discount: {
                        amount: 45,
                        percentage: 50,
                        price: '22,50€'
                    },
                    campaignId: '666',
                    name: 'radio_50_0',
                    price: '50€'
                },
                {
                    amount: 100,
                    discount: {
                        amount: 85,
                        percentage: 15,
                        price: '85,00€'
                    },
                    campaignId: '667',
                    name: 'radio_100_1',
                    price: '100€'
                },
                {
                    amount: 300,
                    discount: {
                        amount: 240,
                        percentage: 20,
                        price: '240,00€'
                    },
                    campaignId: '668',
                    name: 'radio_300_2',
                    price: '300€'
                }
            ],
            customPrice: {
                minAmount: 500,
                maxAmount: 3000,
                percentage: 25,
                campaignId: '670'
            },
            flowId: 'R0lGVENBUkRASUIxYjgwMWRiMDlmZDA0NmUxYTI2MzA3MzU3M2ZhYzNhYw%3D%3D',
            maxPercentage: 25,
            conditionInfo: {
                allConditionsEquals: true,
                campaigns: [
                    {
                        maxUsagesInfo: 'Sin límite hasta consumir saldo.',
                        expiryDate: '25/02/2023',
                        operatorsRestrictionInfo: 'Válido para vuelos directos o en conexión operados por Iberia, Iberia Express, Iberia Regional Air Nostrum.',
                        flightDateReturnLimit: '25/02/2023'
                    },
                    null
                ],
                selectedCondition: {
                    maxUsagesInfo: 'Sin límite hasta consumir saldo.',
                    expiryDate: '25/02/2023',
                    operatorsRestrictionInfo: 'Válido para vuelos directos o en conexión operados por Iberia, Iberia Express, Iberia Regional Air Nostrum.',
                    flightDateReturnLimit: '25/02/2023',
                    text: '50€'
                }
            }
        };
    };

}
SubscriptionModelsConfigurationService.$inject = [
    '$filter',
    'SubscriptionModelsAppConstants',
    'CommonsGenericProxy',
    'SubscriptionModelsImportModelService',
    '$location',
    'CommonsNewHttpUtilsErrorService',
    'CommonsModalService',
    'CommonsKeepAliveUtilsService',
    'CurrencyService',
    'SubscriptionModelsRouterConstants',
    'CommonsSessionStorageService'
];
try {
    const mod = angular.module('ib-subscription-models-service-module');
    mod.service(
        'SubscriptionModelsConfigurationService',
        SubscriptionModelsConfigurationService
    );
} catch (error) {
    const mod = angular.module('ib-subscription-models-service-module', []);
    mod.service(
        'SubscriptionModelsConfigurationService',
        SubscriptionModelsConfigurationService
    );
}
